import Header from '../../../__Layout/Header';
import React from 'react';
import Loader from '../../../utils/Loader';
import { useLongQuestionsListQuery,useSubmitLongQuestionsMutation} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import {Link,useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
export default function LongQuestionDetail() {   
    const { courseId,lqsId } = useParams();
 
    const {
        data: longQuestionsList,
        isLoading: longQuestionsLoader,
    } = useLongQuestionsListQuery({ pageUrl, params: lqsId });
    const validationSchema = Yup.object().shape({
        //  course_id: Yup.string().required("course_id fields is required"),
    });
    let defaultValues = { lqs_id: lqsId,course_id: courseId};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [SubmitLongQuestions,isLoading] = useSubmitLongQuestionsMutation();
    const onSubmit = (values,e) => {
        alert('please read clearly all question answer before submit ');
        SubmitLongQuestions({ data: values })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    if(longQuestionsLoader) return  <Loader></Loader>
   
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">My Courses/Training Detail Mock Exam</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training Details</button>
                        </li>
                        <li>
                            <Link to={`/student-course-topic/${courseId}`} className='btn btn-dark pull-right'>
                              Back
                            </Link>
                        </li>
                       
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                   <div className='col-12'>
                                   <form onSubmit={handleSubmit(onSubmit)} >
                                        <h2 className='text-center'>Start Quiz</h2>
                                        {longQuestionsList?.data?.map((item,index) => { 
                                             return (                                 
                                                 <div key={index}>
                                                    <div className='row mb-4'>
                                                        <div className='col-1'></div>
                                                        <div className='col-10 '>
                                                           <p className='text-warning'>{item.title}</p>
                                                           <input type="hidden" {...register('lqs_id')} className="option"  />
                                                           <input type="hidden" {...register('course_id')} className="option" />

                                                        </div>
                                                        <div className='col-1'></div>
                                                    </div>
                                                    <>
                                                   
                                                    {
                                                        item?.long_questions?.map((key,keyIndex) => { 
                                                            return (                                 
                                                                    <div className="row mb-3" key={keyIndex}>
                                                                        <label htmlFor="inputText" className="col-sm-12 col-form-label text-capitalize">{keyIndex+1} # {key.title}</label>
                                                                        <div className="col-sm-12">
                                                                        <input type="hidden"
                                                                         {...register(`quiz[question][${keyIndex}]`)}
                                                                          className="form-control" value={key.id} />

                                                                            <textarea 
                                                                             {...register(`quiz[answers][${keyIndex}]`)} 
                                                                            className="form-control" rows="10"></textarea>
                                                                            {/* <span className="text-danger">{`errors.answers${key.id}?.message`}</span> */}
                                                                        </div>
                                                                    </div>
                                                                    )  
                                                        }) 
                                                        
                                                    }
                                                    </>
                                                    
                                                 </div>
                                             )  
                                            })  
                                         }
                      
                                        <div className="row mb-3">
                                            
                                            <div className="col-sm-12">
                                                    {isLoading.status !='pending' ? 
                                                                
                                                    <button type="submit" className="btn btn-warning w-100" >Submit Quiz</button>
                                                    :
                                                    <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                                    }
                                            </div>
                                        </div>
                                    </form>
                                   </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
